// 简单的原生JS弹窗实现
let currentModal = null;

// 移除当前弹窗
function removeCurrentModal() {
  if (currentModal && currentModal.parentNode) {
    currentModal.parentNode.removeChild(currentModal);
  }
  currentModal = null;
}

// 创建弹窗HTML
function createModalHTML(type, title, message) {
  // 图标配置
  const iconConfig = {
    error: {
      background: '#ff4d4f',
      emoji: '☹'
    },
    success: {
      background: '#52c41a', 
      emoji: '😊'
    }
  };

  const config = iconConfig[type] || iconConfig.error;

  return `
    <div class="custom-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.45);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      animation: fadeIn 0.2s ease;
    ">
      <div class="custom-modal-container" style="
        background: white;
        border-radius: 6px;
        min-width: 280px;
        max-width: 350px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        animation: modalSlideIn 0.25s ease;
        overflow: hidden;
        border: 1px solid #e8e8e8;
      ">
        <div class="custom-modal-content" style="padding: 20px 24px;">
          <!-- 标题 -->
          <div class="custom-modal-title" style="
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-bottom: 16px;
            text-align: left;
          ">${title}</div>
          
          <!-- 内容区域 -->
          <div class="custom-modal-body" style="
            display: flex;
            align-items: center;
            margin-bottom: 20px;
          ">
            <!-- 图标 -->
            <div class="custom-modal-icon" style="
              width: 24px;
              height: 24px;
              border-radius: 50%;
              background: ${config.background};
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 8px;
              flex-shrink: 0;
            ">
              <span style="
                color: white;
                font-size: 14px;
                line-height: 1;
              ">${config.emoji}</span>
            </div>
            
            <!-- 消息文本 -->
            <div class="custom-modal-message" style="
              flex: 1;
              line-height: 1.4;
              font-size: 14px;
              color: #666;
              word-break: break-word;
            ">${message}</div>
          </div>
          
          <!-- 按钮区域 -->
          <div class="custom-modal-footer" style="text-align: right;">
            <button class="custom-modal-button" style="
              background: #1890ff;
              color: white;
              border: none;
              padding: 6px 15px;
              border-radius: 4px;
              cursor: pointer;
              font-size: 14px;
              min-width: 60px;
              box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
              transition: background-color 0.3s;
            ">确定</button>
          </div>
        </div>
      </div>
    </div>
    <style>
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes modalSlideIn {
        from {
          opacity: 0;
          transform: scale(0.95) translateY(-10px);
        }
        to {
          opacity: 1;
          transform: scale(1) translateY(0);
        }
      }
      .custom-modal-button:hover {
        background: #40a9ff !important;
      }
      .custom-modal-button:active {
        background: #096dd9 !important;
      }
    </style>
  `;
}

// 显示自定义弹窗
function showCustomModal(options = {}) {
  const {
    type = 'info',
    title = '提示',
    message = '',
    closeOnClickOutside = true,
    duration = 0,
    onConfirm = null,
    onClose = null
  } = options;

  console.log('showCustomModal 被调用，参数:', options);

  // 移除现有弹窗
  removeCurrentModal();

  // 创建弹窗元素
  const modalElement = document.createElement('div');
  modalElement.innerHTML = createModalHTML(type, title, message);
  currentModal = modalElement;

  // 添加到body
  document.body.appendChild(modalElement);

  // 绑定事件
  const confirmBtn = modalElement.querySelector('.custom-modal-button');
  const overlay = modalElement.querySelector('.custom-modal-overlay');

  const handleClose = () => {
    removeCurrentModal();
    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm && typeof onConfirm === 'function') {
      onConfirm();
    }
    handleClose();
  };

  if (confirmBtn) {
    confirmBtn.addEventListener('click', handleConfirm);
  }

  if (overlay && closeOnClickOutside) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        handleClose();
      }
    });
  }

  // 自动关闭
  if (duration > 0) {
    setTimeout(handleClose, duration);
  }

  return { close: handleClose };
}

// 错误弹窗
export function showErrorModal(message, options = {}) {
  console.log('showErrorModal 被调用，参数:', message);
  return showCustomModal({
    type: 'error',
    title: '错误',
    message,
    ...options
  });
}

// 成功弹窗
export function showSuccessModal(message, options = {}) {
  return showCustomModal({
    type: 'success',
    title: '成功',
    message,
    duration: options.duration || 2000,
    ...options
  });
}

// 信息弹窗
export function showInfoModal(message, options = {}) {
  return showCustomModal({
    type: 'info',
    title: '提示',
    message,
    ...options
  });
}

// 导出
export { showCustomModal, removeCurrentModal as closeCurrentModal };